import { lazy } from "react";
import { RequirePermission } from "../components/RequirePermission";
import { WorkspaceHome } from "../features/workspace/WorkspaceHome";
import { Navigate, Route } from "react-router";
import { ContactsRedirect } from "../features/contacts/ContactsRedirect";

const ChannelHealthCenter = lazy(() =>
  import("../features/channels-health").then((m) => ({ default: m.ChannelHealthCenter })),
);
const WeeklySummaryPage = lazy(() =>
  import("../features/reports").then((m) => ({ default: m.WeeklySummaryPage })),
);
const ChannelsPage = lazy(() =>
  import("../features/channels/whatsapp-cloud/ChannelsPage").then((m) => ({
    default: m.ChannelsPage,
  })),
);
const OnboardingWizard = lazy(() =>
  import("../features/onboarding/OnboardingWizard").then((m) => ({ default: m.OnboardingWizard })),
);
const SupportPage = lazy(() =>
  import("../features/support/SupportPage").then((m) => ({ default: m.SupportPage })),
);
const SupportTicketPage = lazy(() =>
  import("../features/support/SupportTicketPage").then((m) => ({ default: m.SupportTicketPage })),
);
const SallaOnboardingWizard = lazy(() =>
  import("../features/apps/salla-onboarding").then((m) => ({ default: m.SallaOnboardingWizard })),
);
const GettingStartedPage = lazy(() =>
  import("../features/workspace/GettingStartedPage").then((m) => ({
    default: m.GettingStartedPage,
  })),
);
const GalleryPage = lazy(() =>
  import("../pages/gallery").then((m) => ({ default: m.GalleryPage })),
);
const HelpArticlePage = lazy(() =>
  import("../pages/help-center").then((m) => ({ default: m.HelpArticlePage })),
);
const HelpCenterPage = lazy(() =>
  import("../pages/help-center").then((m) => ({ default: m.HelpCenterPage })),
);
const VideoLibraryPage = lazy(() =>
  import("../pages/help-center/video-library").then((m) => ({ default: m.VideoLibraryPage })),
);
const VideoPage = lazy(() =>
  import("../pages/help-center/video-library").then((m) => ({ default: m.VideoPage })),
);
const ConversationsPage = lazy(() =>
  import("../features/mobile-shell/ConversationsPage").then((m) => ({
    default: m.ConversationsPage,
  })),
);
const GroupsPage = lazy(() =>
  import("../features/groups/GroupsPage").then((m) => ({ default: m.GroupsPage })),
);
const ContactsListPage = lazy(() =>
  import("../features/contacts/ContactsListPage").then((m) => ({ default: m.ContactsListPage })),
);
const ContactProfile = lazy(() =>
  import("../features/contacts/profile/ContactProfile").then((m) => ({
    default: m.ContactProfile,
  })),
);
const MigrationWizard = lazy(() =>
  import("../pages/migration/wizard-entry").then((m) => ({ default: m.MigrationWizard })),
);
const ReconnectPage = lazy(() =>
  import("../pages/migration/reconnect").then((m) => ({ default: m.ReconnectPage })),
);

// Route order inside <Route path="/w/:workspaceId"> is preserved: this fragment slots in where it was inline.
export const workspaceCoreRoutes = (
  <>
    <Route index element={<WorkspaceHome />} />
    {/* OWN-164: open to every member; the API leaves out the sections a role may not see. */}
    {/* OWN-319: the follow-up dashboard became the reports section of Home */}
    <Route
      path="overview"
      element={<Navigate to={{ pathname: "..", hash: "#reports" }} relative="path" replace />}
    />
    <Route path="onboarding/classic" element={<OnboardingWizard />} />
    <Route path="getting-started" element={<GettingStartedPage />} />
    <Route path="gallery" element={<GalleryPage />} />
    <Route path="support" element={<SupportPage />} />
    <Route path="support/:ticketId" element={<SupportTicketPage />} />
    <Route path="help-center" element={<HelpCenterPage />} />
    <Route path="help-center/videos" element={<VideoLibraryPage />} />
    <Route path="help-center/videos/:feature" element={<VideoPage />} />
    <Route path="help-center/:slug" element={<HelpArticlePage />} />
    <Route path="apps/salla/onboarding" element={<SallaOnboardingWizard />} />
    <Route path="migration" element={<MigrationWizard />} />
    <Route path="migration/reconnect" element={<ReconnectPage />} />
    <Route path="contacts" element={<ContactsListPage />} />
    {/* b29-04: one customers page; the old sub-pages keep working as deep links. */}
    <Route path="contacts/segments" element={<ContactsRedirect />} />
    <Route path="contacts/lists" element={<ContactsRedirect />} />
    <Route path="contacts/duplicates" element={<ContactsRedirect />} />
    <Route path="contacts/import" element={<ContactsRedirect dialog="import" />} />
    <Route path="contacts/:contactId" element={<ContactProfile />} />
    <Route path="conversations" element={<ConversationsPage />} />
    <Route
      path="groups"
      element={
        <RequirePermission anyOf={["inbox.view"]}>
          <GroupsPage />
        </RequirePermission>
      }
    />
    <Route path="channels" element={<ChannelsPage />} />
    <Route
      path="reports/weekly"
      element={
        <RequirePermission anyOf={["analytics.view"]}>
          <WeeklySummaryPage />
        </RequirePermission>
      }
    />
    <Route
      path="channels/health"
      element={
        <RequirePermission anyOf={["channels.view"]}>
          <ChannelHealthCenter />
        </RequirePermission>
      }
    />
  </>
);
